import { defineStore, acceptHMRUpdate } from 'pinia';
import { apiClient } from '@/api/client';
import { useToast } from 'vue-toastification';
import socket from '@/socket';

const toast = useToast();
const useWorkWithUsStore = defineStore({
    id: 'workWithUs',
    state: () => ({
        eggDescList: [
            {
                eggIconObj: { componentName: 'workWithUs', imgName: 'heart', imgFormat: 'svg', width: '6.5vw', height: '6.5rem' },
                label: 'workWithUs.heartDesc'
            },
            {
                eggIconObj: { componentName: 'workWithUs', imgName: 'people', imgFormat: 'svg', width: '6.5vw', height: '7.5rem' },
                label: 'workWithUs.peopleDesc'
            },
            {
                eggIconObj: { componentName: 'workWithUs', imgName: 'leaves', imgFormat: 'svg', width: '6.5vw', height: '7.5rem' },
                label: 'workWithUs.leavesDesc'
            }
        ],
        administrationList: [
            {
                id: 'serviceCentreAdmin',
                title: 'workWithUs.serviceCentreAdmin',
                titleDescription: 'workWithUs.fullTime',
                description: 'workWithUs.serviceCentreAdminDesc',
                isExpand: false,
                showShareBtn: true,
            },
            {
                id: 'adminAssistant',
                title: 'workWithUs.adminAssistant',
                titleDescription: 'workWithUs.fullTime',
                description: 'workWithUs.adminAssistantDesc',
                isExpand: false,
                showShareBtn: true,

            },
            {
                id: 'adminOfficer',
                title: 'workWithUs.adminOfficer',
                titleDescription: 'workWithUs.fullTime',
                description: 'workWithUs.adminOfficerDesc',
                isExpand: false,
                showShareBtn: true,

            },
            {
                id: 'tempClerk',
                title: 'workWithUs.tempClerk',
                titleDescription: 'workWithUs.partTime',
                description: 'workWithUs.tempClerkDesc',
                isExpand: false,
                showShareBtn: true,
            },
        ],
        form: {
            categoryList: [
                'workWithUs.generalPract',
                'workWithUs.specialist',
                'workWithUs.alliedHealProf',
                'workWithUs.regNurse',
                'workWithUs.enrolNurse',
                'workWithUs.healthAssist',
                'workWithUs.other'
            ]
        }
    }),
    getters: {},
    actions: {
        async workWithUs(body: object) {
            try {
                console.log('api: Work With Us: ' + JSON.stringify(body));
                const response: any = await apiClient.post('/api/scwebsite/workWithUs/', body);
                const isSuccess = response.statusCode;
                //debugger;
                if (!isSuccess) {
                    console.log('response? ' + JSON.stringify(response));
                    var error = Object.prototype.toString.call(response.errorMessage) === '[object Object]' ? JSON.stringify(response.errorMessage) : response.errorMessage;
                    throw new Error(error)
                }
                toast.success('Send Email Success');
                return isSuccess;
            } catch (err: any) {
                toast.error(err.message);
            }
        },
    },

});
// make sure to pass the right store definition
if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useWorkWithUsStore, import.meta.hot));
}

export { useWorkWithUsStore };
